export const queryKeys = {
  USERS: "users",
  BUILDINGS: "buildings"
};
